import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=An%20artistic%20overhead%20flat%20lay%20of%20a%20curated%20streetwear%20haul%20featuring%20a%20pair%20of%20white%20sneakers%20a%20folded%20caramel%20knit%20sweater%20a%20denim%20jacket%20sunglasses%20and%20a%20canvas%20tote%20bag%20arranged%20in%20a%20loose%20grid%20on%20a%20soft%20warm%20parchment%20background%20with%20scattered%20small%20props%20and%20subtle%20hand%20drawn%20line%20accents%20editorial%20lifestyle%20mood%20board%20aesthetic%20soft%20diffused%20lighting%20warm%20cream%20taupe%20and%20terracotta%20palette%20high%20detail%20balanced%20composition&width=1600&height=900&seq=hero-2026-v2&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="AllChinaBuy Spreadsheet — curated fashion and streetwear product resources"
          title="AllChinaBuy Spreadsheet product resources"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm whitespace-nowrap">
          <i className="ri-sparkling-2-line"></i>
          {t('home.eyebrow')}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-semibold leading-tight text-background-50 md:text-5xl">
          {t('home.h1')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          {t('home.heroCopy')}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t('buttons.allchinabuySpreadsheet')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t('buttons.buyItNow')}
            <i className="ri-shopping-bag-3-line"></i>
          </a>
        </div>

        <p className="mt-6 text-xs tracking-wide text-background-200">{t('home.trustText')}</p>
      </div>
    </section>
  );
}